// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"6789":"c9ee3f8f75d24b5a","7564":"549a0366147f4539","8220":"c1e35734739bc181"}[chunkId] + ".css";
};